import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table'

const commissionHistory = [
  { date: '2024-01-15', driver: 'Carlos Silva', rides: 12, amount: 24.5 },
  { date: '2024-01-15', driver: 'Maria Santos', rides: 8, amount: 18.3 },
  { date: '2024-01-14', driver: 'Ana Costa', rides: 15, amount: 32.8 },
  { date: '2024-01-14', driver: 'Pedro Lima', rides: 9, amount: 19.75 },
  { date: '2024-01-13', driver: 'Carlos Silva', rides: 11, amount: 22.1 }
]
export default function DashboardCommisionsTab() {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Histórico de Comissões</CardTitle>
          <CardDescription>
            Detalhamento das comissões recebidas por motorista e período
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Data</TableHead>
                <TableHead>Motorista</TableHead>
                <TableHead>Corridas</TableHead>
                <TableHead>Comissão</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {commissionHistory.map((entry, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {new Date(entry.date).toLocaleDateString('pt-BR')}
                  </TableCell>
                  <TableCell>{entry.driver}</TableCell>
                  <TableCell>{entry.rides}</TableCell>
                  <TableCell className="font-medium text-green-600">
                    R$ {entry.amount.toFixed(2)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </>
  )
}
